import * as React from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'

import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Grid from '@material-ui/core/Grid'
import MenuItem from '@material-ui/core/MenuItem'
import TextField from '@material-ui/core/TextField'
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Card from '@material-ui/core/Card/Card'
import CardContent from '@material-ui/core/CardContent/CardContent'
import Button from '@material-ui/core/Button'
import { FieldArray } from 'formik'
import { AccountType } from '../../../api'
import { AbstractedFormikTextField, InlineError } from '../../atoms'
import { InlineDatePicker } from '../../atoms/DatePicker'
import { Couple } from '../../molecules'
import AddCoupleForm from '../CoupleAddForm'
import Info from '@material-ui/icons/Info'
import Tooltip from "@material-ui/core/Tooltip";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import { post } from "../../../config";
interface State {
  mentor: string
  mentee: string
  mentorStatus: string
  menteeStatus: string
  showConfirmDialog: string
}

interface Props {
  mode: any
  companies: any
  handleChange: any
  values: any
  errors: any
  touched: any
  classes: any
  intl: any
}


class Chunk extends React.Component<Props, State> {
  constructor(props) {
    super(props)
    this.state = {
      mentor: '',
      mentee: '',
      mentorStatus: '',
      menteeStatus: '',
      showConfirmDialog: ''
    }
    console.log("PROPS", props);
  }

  handleChange = (value, param) => {
    switch (param) {
      case "mentor":
        this.setState(s => ({
          mentor: value
        }))
        return
      case "mentee":
        this.setState(s => ({
          mentee: value
        }))
        return
    }
  }

  saveMentor = async () => {
    const { mentor } = this.state
    if (mentor) {
      try {
        this.setState({ mentorStatus: 'sending', showConfirmDialog: '' })
        await post(`/automaticmatch`, {
          mentor: this.state.mentor,
          program: this.props.values.name
        })
        this.setState({ mentorStatus: 'sent' })
      } catch (e) {
        console.error(e)
        this.setState({ mentorStatus: 'error', showConfirmDialog: '' })
      }
    }
  }

  saveMentee = async () => {
    const { mentee } = this.state
    if (mentee) {
      try {
        this.setState({ menteeStatus: 'sending', showConfirmDialog: '' })
        await post(`/automaticmatch`, {
          mentee: this.state.mentee,
          program: this.props.values.name
        })
        this.setState({ menteeStatus: 'sent' })
      } catch (e) {
        console.error(e)
        this.setState({ menteeStatus: 'error', showConfirmDialog: '' })
      }
    }
  }

  handleClose = () => {
    this.setState({ showConfirmDialog: '' })
  }

  render() {
    const { mode } = this.props
    const theme = createMuiTheme({
      overrides: {
        MuiTooltip: {
          tooltip: {
            backgroundColor: "black",
            maxWidth: 180
          }
        }
      }
    });
    const isCreate = mode === 'create'

    return (
      <Grid container spacing={24}>

        {this.state.showConfirmDialog !== '' && <Dialog
          open={this.state.showConfirmDialog !== ''}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              "{this.props.values.name}" <FormattedMessage id={'automaticmatch.dialog'} />
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button style={{textTransform: 'capitalize'}} onClick={this.handleClose}>
              <FormattedMessage id={'automaticmatch.cancel'} />
            </Button>
            <Button style={{textTransform: 'capitalize'}} onClick={this.state.showConfirmDialog === 'mentor' ? this.saveMentor : this.saveMentee} color="primary" autoFocus>
              <FormattedMessage id={'automaticmatch.ok'} />
            </Button>
          </DialogActions>
        </Dialog>}

        {isCreate && (
          <Grid item xs={12}>
            <AbstractedFormikTextField
              {...this.props}
              autoFocus
              fullWidth
              identifier={'companyId'}
              select
              InputLabelProps={{ shrink: true }}
            >
              {this.props.companies.map(({ name, id }: any) => (
                <MenuItem key={id} value={id}>
                  {name}
                </MenuItem>
              ))}
            </AbstractedFormikTextField>
          </Grid>
        )}

        <Grid item xs={12}>
          <AbstractedFormikTextField
            {...this.props}
            fullWidth
            identifier={'name'}
            label={'title'}
          />
        </Grid>

        {isCreate && (
          <>
            <Grid item xs={12}>
              <InlineDatePicker
                fullWidth
                label={'start'}
                name={'start'}
                onChange={this.props.handleChange}
                value={this.props.values.start}
                format={'DD/MM/YYYY'}
              />
            </Grid>
            <Grid item xs={12}>
              <InlineDatePicker
                fullWidth
                label={'end'}
                name={'end'}
                onChange={this.props.handleChange}
                value={this.props.values.end}
                format={'DD/MM/YYYY'}
              />
            </Grid>
          </>
        )}

        <Grid item xs={12}>
          <AbstractedFormikTextField
            {...this.props}
            fullWidth
            identifier={'sessions'}
            type={'number'}
          />
        </Grid>
        <Grid item>
          <Grid container xs={12} alignItems={'center'}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={this.props.values.automaticMatch}
                  onChange={this.props.handleChange}
                  id={'automaticMatch'}
                />
              }
              label={(
                <FormattedMessage id={'generic.autoMatching'} />
              )}
            />
            <MuiThemeProvider theme={theme}>
              <Tooltip title={<FormattedMessage id={'automaching.text'} />} placement="top" classes={this.props.classes}>
                <Info />
              </Tooltip>
            </MuiThemeProvider>
          </Grid>
        </Grid>
        {
          this.props.values.automaticMatch ?
            <Grid
              container
              justify={'space-between'}
              xs={12}
              spacing={8}
            >
              <Grid item xs={6} md={6}>
                <Card>
                  <CardContent>
                    <TextField
                      type='text'
                      value={this.state.mentor}
                      onChange={(e) => this.handleChange(e.currentTarget.value, 'mentor')}
                      label='Mentor'
                      helperText={this.state.mentorStatus == 'sent' ? this.props.intl.formatMessage({ id: 'invitation.sent' }) : ''}
                      fullWidth
                      style={{
                        marginBottom: 15
                      }}
                    />
                    <Button style={{textTransform: 'capitalize'}} disabled={this.state.mentor.length == 0} color={'primary'} onClick={() => {
                      this.setState({showConfirmDialog: 'mentor'})
                    }}>
                      <FormattedMessage id='buttonActions.submitinvite' />
                    </Button>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={6} md={6}>
                <Card>
                  <CardContent>
                    <TextField
                      type='text'
                      value={this.state.mentee}
                      onChange={(e) => this.handleChange(e.currentTarget.value, 'mentee')}
                      label='Mentee'
                      helperText={this.state.menteeStatus == 'sent' ? this.props.intl.formatMessage({ id: 'invitation.sent' }) : ''}
                      fullWidth
                      style={{
                        marginBottom: 15
                      }}
                    />
                    <Button style={{textTransform: 'capitalize'}} disabled={this.state.mentee.length == 0} color={'primary'} onClick={() => {
                      this.setState({showConfirmDialog: 'mentee'})
                    }}>
                      <FormattedMessage id='buttonActions.submitinvite' />
                    </Button>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
            :
            <FieldArray
              name={'processes'}
              render={({ push, remove, replace, form: { values } }) => (
                <>
                  <Grid item xs={12}>
                    <AddCoupleForm
                      teacherType={AccountType.Mentor}
                      studentType={AccountType.Mentee}
                      onSubmit={push}
                      automaticMatch={this.props.values.automaticMatch}
                    />
                  </Grid>
                  {values.processes.map((process: any, i: any) => (
                    <Grid
                      item
                      xs={12}
                      key={
                        (process.student.email || process.student)
                        + (process.teacher.email || process.teacher)
                        + i
                      }
                    >
                      <Couple
                        teacher={process.teacher.email || process.teacher}
                        student={process.student.email || process.student}
                        platform={'mentoring'}
                        onRemove={() => remove(i)}
                        onSave={couple => replace(i, { ...values.processes[i], ...couple })}
                        automaticMatch={this.props.values.automaticMatch}
                      />
                    </Grid>
                  ))}
                </>
              )}
            />}
        {this.props.errors.processes && this.props.touched.processes && (
          <Grid item xs={12}>
            <InlineError i18nErrorId={'validation.' + this.props.errors.processes} />
          </Grid>
        )}
      </Grid>
    )
  }

}

export default injectIntl(Chunk)



// WEBPACK FOOTER //
// ./src/components/forms/chunks/MentoringProgramChunk.tsx